export const formatSpotRegion = (value: string): string =>
  value
    .replace(/^(bp)?[Ss]pot[Rr]egion_?/, '')
    .replace(/^SpotRegion_?/i, '')
    .replace(/_/g, ' ')
    .replace(/([a-zA-Z])(\d)/g, '$1 $2')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace('landing', 'Landing');

export const replaceAssistantPlaceholders = (
  text: string,
  userName?: string,
  experienceName?: string,
) =>
  text
    .replace(/\{\{user\}\}/g, userName?.trim() ?? '')
    .replace(/\{\{experience\}\}/g, experienceName?.trim() ?? '');
